import { SelectChangeEvent } from "@mui/material";
import { useStore } from "../../store/store";
import { hingeEmtek, hinge } from "../Hinge/defaults";
import { useRequiredMsgs } from "../../store/requiredMsgs";
import { useEffect } from "react";
import { concealedHingeOption } from "./defaults";

function useSquareHingeSelector() {
  const addToQuote = useStore((state) => state.addToQuote);
  const squareHinges = useStore((state) => state.quote.squareHinges);
  const hingeColor = useStore((state) => state.quote.hingeColor);
  const findRequired = useRequiredMsgs((state) => state.findRequired);
  const removeRequired = useRequiredMsgs((state) => state.removeRequired);
  const stilesAndRails = useStore((state) => state.quote.stilesAndRails);
  const isPico = stilesAndRails?.includes("Pico");

  const handleClick = (label: string) => {
    const checked = checkMark(label);
    if (checked) {
      addToQuote({ squareHinges: "", hingeColor: "" }, "hingeColor");
    } else {
      addToQuote({ squareHinges: label, hingeColor: "" }, "hingeColor");
    }
  };

  const handleChange = (event: SelectChangeEvent<string>) => {
    const value = event.target.value

    if (!value) {
      addToQuote({ hingeColor: "" }, "hingeColor");
    } else {
      addToQuote({ hingeColor: value });
      if (findRequired("Hinge Color")) {
        removeRequired("Hinge Color");
      }
    }
  };

  const variant = (label: string) =>
    label === squareHinges ? "filled" : "outlined";

  const checkMark = (label: string) => label === squareHinges;

  const hingeOptions = squareHinges ? hingeEmtek : hinge;

  return {
    handleClick,
    variant,
    checkMark,
    squareHinges,
    handleChange,
    hingeColor,
    hingeOptions,
    isPico
  };
}

export default useSquareHingeSelector;
